import axios from 'axios'
import _config from '@/config'
import {Message} from 'element-ui';
import { getToken } from './token' 
 /* eslint-disable */
const config = {
  baseURL: _config.baseUrl,
  timeout: 30 * 1000
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  originConfig => {
    const accessToken = getToken('access_token')
    originConfig.headers.Authorization = accessToken
    return originConfig
  },
  error => {
    Promise.reject(error)
  }
)

_axios.interceptors.response.use(
  async res => {
    let { data, code, msg } = res.data
    if (res.status.toString().charAt(0) === '2') {
      if  (code !== 2000) {
        Message ({
          message: msg,
          type: 'error',
          duration: 5 * 1000,
        })
        return
      }
      return data
    }
    return new Promise(resolve, reject => {

    })
  },
  error => {
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
      Message ({
        type: 'warning',
        message: '请求超时',
        duration: 20 * 1000,
      });
    }
    return Promise.reject(error)
  }
)

export default _axios